export const DASHBOARD = {
  page: 'dashboard-page',
  newAnalysisButton: 'dashboard-new-analysis-button',
  reportsList: 'dashboard-reports-list',
  reportCard: 'dashboard-report-card',
  emptyState: 'dashboard-empty-state',
  noResultsState: 'dashboard-no-results-state',
  uploadFirstButton: 'dashboard-upload-first-button',
  loadingState: 'dashboard-loading-state',
  searchInput: 'dashboard-search-input',
  filterToggleButton: 'dashboard-filter-toggle-button',
  statusFilterButton: 'dashboard-status-filter-button',
  dateFilterButton: 'dashboard-date-filter-button',
  sortSelect: 'dashboard-sort-select',
  resultsCount: 'dashboard-results-count',
  clearFiltersButton: 'dashboard-clear-filters-button',
  trendPatientLink: 'dashboard-trend-patient-link',
  deleteModal: 'dashboard-delete-modal',
  deleteModalBackdrop: 'dashboard-delete-modal-backdrop',
  deleteModalClose: 'dashboard-delete-modal-close',
  deleteModalConfirm: 'dashboard-delete-modal-confirm',
  deleteModalCancel: 'dashboard-delete-modal-cancel',
};
